import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { environment } from 'src/environments/environment';
import { AttributeDataService } from '../../services/attribute-data.service';
import { ComponentsService } from '../../services/components.service';
import { DataTableContentEditorComponent } from '../data-table-common/data-table-content-editor.component';
import {
  DataTableField,
  DataTableSnapshot,
} from '../data-table-common/data-table.types';

@Component({
  selector: 'template-component-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss'],
  standalone: false,
})
export class DataTableComponent {
  @ViewChild('contentEditor')
  contentEditor: DataTableContentEditorComponent;

  componentId: string;

  constructor(
    private elementRef: ElementRef,
    private componentsService: ComponentsService,
    private attributeDataService: AttributeDataService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.componentsService.registerDirective({
      type: 'rise-data-table',
      element: this.elementRef.nativeElement,
      show: () => {
        this.componentId = this.componentsService.selected.id;
        // Call detectChanges to update contentEditor.componentId before calling load() because contentEditor.componentId is an @Input() field
        this.changeDetectorRef.detectChanges();
        void this.contentEditor?.load();
      },
    });
  }

  loadContentData = (): DataTableSnapshot => {
    const values = this.attributeDataService.getAvailableAttributeData(
      this.componentId,
      'values',
    );
    const fields = this.attributeDataService.getAvailableAttributeData(
      this.componentId,
      'fields',
    );
    const source = this.attributeDataService.getAvailableAttributeData(
      this.componentId,
      'source',
    );
    const account = this.attributeDataService.getAvailableAttributeData(
      this.componentId,
      'account',
    );
    const name =
      this.attributeDataService.getAvailableAttributeData(
        this.componentId,
        'name',
      ) || '';
    const hideFirstRow = this.attributeDataService.getAvailableAttributeData(
      this.componentId,
      'hideFirstRow',
    );

    let parsedFields: DataTableField[] = [];
    if (fields) {
      parsedFields = JSON.parse(fields);
    }

    let parsedValues: any[][] = [];
    if (values) {
      parsedValues = JSON.parse(values);
    }

    return {
      fields: parsedFields,
      values: parsedValues,
      source: source ?? null,
      account: account ?? null,
      name,
      hideFirstRow: hideFirstRow === undefined ? true : hideFirstRow,
    };
  };

  saveContentData = (snapshot: DataTableSnapshot): void => {
    this.attributeDataService.setAttributeData(
      this.componentId,
      'values',
      JSON.stringify(snapshot.values),
    );
    this.attributeDataService.setAttributeData(
      this.componentId,
      'environment',
      environment.production ? 'prod' : 'test',
    );
    this.attributeDataService.setAttributeData(
      this.componentId,
      'account',
      snapshot.account,
    );
    this.attributeDataService.setAttributeData(
      this.componentId,
      'source',
      snapshot.source,
    );
    this.attributeDataService.setAttributeData(
      this.componentId,
      'name',
      snapshot.name,
    );
    this.attributeDataService.setAttributeData(
      this.componentId,
      'hideFirstRow',
      snapshot.hideFirstRow,
    );
  };
}
